






import { Component, Prop, Vue } from 'vue-property-decorator';
import RoubleCurrency from '@/components/ext/currency/Rouble.vue';
import nf from '@/tools/number/format.js';

enum currencies {
  RUR = 'RUR',
}

const currenciesTags = {
  [currencies.RUR]: 'rouble-currency',
};

@Component({
  components: { RoubleCurrency },
})
export default class ComponentPartCatalogListCardPrice extends Vue {
  @Prop({ type: Number, required: true })
  value: number;

  @Prop({ type: String, default: currencies.RUR })
  currency: currencies;

  get priceFormatted(): string {
    const price = this.value || 0;
    return nf(price, 0, '', ' ');
  }

  get currencyTag(): string {
    const { currency } = this;
    return typeof currenciesTags[currency] === 'undefined'
      ? 'span'
      : currenciesTags[currency];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/components/Price.vue